<script>
import {deleteGrv, verificarEfeitosColateraisDelete} from '../../../../domain/grv/services'
import {isArray} from 'lodash'

export default {
  name: 'ExcluirGrvAlerta',
  props: {
    grvId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      atualizadoSucesso: false,
      cadastroError: null,
      isLoaded: false,
      data: null,
      motivoExclusao: null
    }
  },
  computed: {
    impedirExclusao () {
      const {lotes, transmitido} = this.data
      return lotes.length || transmitido.length // || retirado
    },
    isSemMotivo () {
      return !(this.motivoExclusao || '').length
    },
    hasParentLoading () {
      return this.$parent && typeof this.$parent.loading === 'function'
    }
  },
  created () {
    this.load()
  },
  methods: {
    load () {
      this.setParentLoading(true)
      verificarEfeitosColateraisDelete(this.grvId)
        .then(result => {
          this.data = result.data
          console.log(result.data)
        })
        .catch(error => {
          alert('Erro ao carregar as informações de exclusão')
          console.log(error)
        })
        .finally(() => {
          this.isLoaded = true
          this.setParentLoading(false)
        })
    },
    deleteGrv () {
      if (this.isSemMotivo) return alert('Explique o motivo para a exclusão desta GRV.')
      const podeExcluir = confirm('Confirmar exclusão?')
      if (!podeExcluir) return
      this.setParentLoading(true)
      deleteGrv(this.grvId, this.motivoExclusao)
          .then(result => {
            this.$emit('finishSubmit')
            this.atualizadoSucesso = true
          })
          .catch(error => {
            alert('Erro ao excluir GRV')
            console.log(error)
            this.cadastroError = error.data.errors
          })
        .finally(() => {
          this.setParentLoading(false)
        })
    },
    setParentLoading (option) {
      this.hasParentLoading && this.$parent.loading(option)
    },
    printError (err) {
      if (isArray(err)) {
        return err[0]
      }
      return err
    }
  }
}
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded && !atualizadoSucesso" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-12"><h1 class="m-n font-thin h3">Exclusão de GRV</h1></div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao excluir GRV</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">Excluído com sucesso!</div>
            </div>

            <h4>Atenção! Esta GRV está ligada aos seguintes itens:</h4>
            <small>Os itens abaixo serão excluídos do sistema. <strong class="text-danger text-uppercase">Esta operação não pode ser desfeita</strong></small>
            <div class="row m-t-lg">
              <div class="col-sm-6">
                <ul class="list-unstyled l-h-2x lista-efeitos-colaterais">
                  <li>{{data.fotos}} Foto{{data.fotos !== 1 && 's' || ''}}</li>
                  <li>{{data.equipamentos}} Equipamento{{data.equipamentos !== 1 && 's' || ''}}</li>
                  <li>{{data.lacres}} Lacre{{data.lacres !== 1 && 's' || ''}}</li>
                  <li>{{data.atendimentos}} Atendimento{{data.atendimentos !== 1 && 's' || ''}}</li>
                  <li>{{data.notificacoes_telegrama}} Notificaç{{data.notificacoes_telegrama !== 1 && 'ões' || 'ão'}} de Telegrama</li>
                </ul>
              </div>
              <div class="col-sm-6">
                <ul class="list-unstyled l-h-2x lista-efeitos-colaterais">
                  <li>{{data.transferencias}} Transferência{{data.transferencias !== 1 && 's' || ''}} de Pátio</li>
                  <li>{{data.historicosLocalizacao}} Histórico{{data.historicosLocalizacao !== 1 && 's' || ''}} de Localização</li>
                  <li>{{data.pericia ? 'Possui' : 'Não possui'}} Perícia</li>
                  <li>{{data.preretiradas}} Pré-retirada{{data.preretiradas !== 1 && 's' || ''}}</li>
                  <li>{{data.ggv ? 'Possui' : 'Não possui'}} GGV</li>
                </ul>
              </div>
            </div>

            <hr v-if="data.tasks.length">

            <h4 class="m-b-lg" v-if="data.tasks.length"><i class="fa fa-exclamation-triangle text-danger"></i> Esta GRV possui as seguintes tasks:</h4>
            <div class="row" v-if="data.tasks.length">
              <div class="col-sm-12">
                <ul class="list-unstyled l-h-2x">
                  <li v-for="task in data.tasks">Task #{{task.id}}: {{task.description}} (<small>{{task.executed ? 'executada' : 'não executada'}}</small>)</li>
                </ul>
              </div>
            </div>

            <hr v-if="data.lotes.length">

            <h4 class="m-b-lg" v-if="data.lotes.length"><i class="fa fa-exclamation-triangle text-danger"></i> Esta GRV está ligada aos seguintes leilões:</h4>
            <div class="row" v-if="data.lotes.length">
              <div class="col-sm-12">
                <ul class="list-unstyled l-h-2x">
                  <li v-for="lote in data.lotes">Lote <strong>{{lote.lote}}</strong> no leilão <strong>{{lote.tituloLeilao}}</strong></li>
                </ul>
              </div>
            </div>

            <div class="row" v-if="!impedirExclusao">
              <div class="col-sm-12">
                <div class="">
                  <textarea class="form-control" rows="4" v-model.trim="motivoExclusao" placeholder="Motivo da exclusão" style="max-height: 50px"/>
                </div>
              </div>
            </div>

            <div class="clearfix"></div>

            <hr>
            <div class="row wrapper" v-if="!impedirExclusao">
              <u-button class="btn m-b-xs w-auto btn-danger m-r-xs" @click="deleteGrv" :disabled="isSemMotivo">
                <span>Confirmar exclusão</span>
              </u-button>
              <u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="$emit('cancel')">Cancelar</u-button>
            </div>
            <div class="row wrapper" v-else>
              <div class="alert alert-danger">
                <div>Esta GRV não pode ser excluída, pois:</div>
                <ul>
                  <li v-if="data.lotes.length">Está relacionada a lotes</li>
                  <li v-if="data.retirado">Veículo foi retirado</li>
                  <li v-if="data.transmitido.length">
                    Já foi transmitida para a DETRO
                    <ul>
                      <li v-for="transmissao in data.transmitido">{{transmissao.description}}</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-transition" v-else-if="atualizadoSucesso">
      <div class="wrapper-md">
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
          <i class="fa fa-check-circle fa-5x text-success"></i>
          <h4 class="m-t-lg">Grv excluída com sucesso!</h4>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
  .lista-efeitos-colaterais li::before {
    content: '=> ';
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// ExcluirGrvAlerta.vue?62fdc289